import { appConfig, headerConfig, refineHeader } from "../../config";

export const salesPersonService = {
  getSalesManager,
  add_cityAccess,
  getSalesPersonCities,
  promote_salesPerson,
  getQuestionsList,
  getSalesPersonReport,
  getCititesForReport,
  getSalesPersonQuestDetail,
  updateAnswer,
  getSalesPersonExportReport,
  gethelpdetail,
  addHelpQuestion,
  updateHelpReply,
  getMonthandYear,
  getProgressReport
};

function getSalesManager(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(
    `${appConfig.api.url}employee-management/sales-manager-list`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function add_cityAccess(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(
    `${appConfig.api.url}employee-management/sales-manager-city`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getSalesPersonCities(postaData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postaData)
  };

  return fetch(
    `${appConfig.api.url}employee-management/sales-manager-city-list`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function promote_salesPerson(postaData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postaData)
  };

  return fetch(
    `${appConfig.api.url}employee-management/promote-to-salesmanager`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getQuestionsList(postaData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postaData)
  };

  return fetch(
    `${appConfig.api.url}question/sales-manager-question-list`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getCititesForReport() {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    // body: JSON.stringify()
  };

  return fetch(
    `${appConfig.api.url}employee-management/sales-manager-cities`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getSalesPersonReport(postaData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postaData)
  };

  return fetch(
    `${appConfig.api.url}report/sales-manager-report`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getSalesPersonExportReport(postaData){
    refineHeader();
    const requestOptions = {
        method: 'POST',
        headers: headerConfig.headerDatas,
        mode: 'cors',
        body: JSON.stringify(postaData )
    };
    
    //return fetch(`${appConfig.api.url}report/manager-sales-report`, requestOptions)
    return fetch(`${appConfig.api.url}report/sales-manager-report-export`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function getSalesPersonQuestDetail(quesID) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors"
  };

  return fetch(`${appConfig.api.url}question/detail/${quesID}`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function updateAnswer(postaData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postaData)
  };

  return fetch(`${appConfig.api.url}question/answer-question`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function gethelpdetail(quesID) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors"
  };

  return fetch(`${appConfig.api.url}/${quesID}`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function addHelpQuestion(postaData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postaData)
  };

  return fetch(`${appConfig.api.url}`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function updateHelpReply(postaData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postaData)
  };

  return fetch(`${appConfig.api.url}`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getMonthandYear() {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors"
  };

  return fetch(`${appConfig.api.url}report/month-year`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getProgressReport(postaData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postaData)
  };

  return fetch(`${appConfig.api.url}report/sales-team-report`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}



// WEBPACK FOOTER //
// ./src/app/services/API/salesPersonService.js